define(function (require) {
    "use strict";

    var $ = require("jquery");

    var GeneralUtils = (function () {

        var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);

        var _setFocusOnElement = function (element) {
            if (isSafari) {
                // On safari if we use  element.attr("tabindex",-1).focus(); there is a border around the element.
                $(element).on("focus.generalUtils", function () {
                    $(element).select().one("mouseup", function (e) {
                        e.preventDefault();
                    });
                });
            } else {
                element.attr("tabindex", 1).focus();
                element.removeAttr("tabindex");
            }
        };

        var _unsetFocusOnElement = function (element) {
            if (isSafari) {
                $(element).off("focus.generalUtils");
            }
        };

        var _addParameter = function (url, param, value) {
            // Using a positive lookahead (?=\=) to find the
            // given parameter, preceded by a ? or &, and followed
            // by a = with a value after than (using a non-greedy selector)
            // and then followed by a & or the end of the string
            var val = new RegExp('(\\?|\\&)' + param + '=.*?(?=(&|$))'),
                parts = url.toString().split('#'),
                hash = parts[1];
            url = parts[0];
            var qstring = /\?.+$/;
            var newURL = url;

            // Check if the parameter exists
            if (val.test(url))
            {
                // if it does, replace it, using the captured group
                // to determine & or ? at the beginning
                newURL = url.replace(val, '$1' + param + '=' + value);
            }
            else if (qstring.test(url))
            {
                // otherwise, if there is a query string at all
                // add the param to the end of it
                newURL = url + '&' + param + '=' + value;
            }
            else
            {
                // if there's no query string, add one
                newURL = url + '?' + param + '=' + value;
            }

            if (hash)
            {
                newURL += '#' + hash;
            }
            return newURL;
        };

        var _delParameter = function (url) {
            var url0 =  url.split("?")[0];
            var url1 =  url.split("?")[1].split("#")[1];
            return url0 + "#" + url1;
        };

        var _preciseRound = function (num, decimals) {
            return (Math.round(num * Math.pow(10, decimals)) / Math.pow(10, decimals)).toFixed(decimals);
        };

        return {
            /**
             * rounds the given value to have max two decimal digit after the floating point
             * @param value
             * @return {number} -- must return a number
             */
            roundValue : function (value) {
                return Math.round(value * 100) / 100;
            },

            /**
             * convert num to have decimals number of digits after the floating point
             * @param num
             * @param decimals
             */
            preciseRound : function (num, decimals) {
                return _preciseRound(num, decimals);
            },

            /**
             * sets focus on element on view
             * @param element
             * @param view
             */
            setFocusOnElement : function (element) {
                _setFocusOnElement(element);
            },

            /**
             * un-sets focus on element on view
             * @param element
             * @param view
             */
            unsetFocusOnElement : function (element) {
                _unsetFocusOnElement(element);
            },

            /**
             * addParameter adds query parameter to url
             * @param url
             * @param param
             * @param value
             */
            addParameter : function (url, param, value) {
                return _addParameter(url, param, value);
            },

            /**
             * delParameter deletes query parameter to url
             * @param url
             */
            delParameter : function (url) {
                return _delParameter(url);
            }
    };
    })();

    return GeneralUtils;
});